var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_387",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29244",
    "data-name": "Group 29244",
    transform: "translate(434 10837)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -434, -10837)",
    filter: "url(#Ellipse_387)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_387-2",
    "data-name": "Ellipse 387",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_50236",
    "data-name": "Path 50236",
    d: "M14.247,6.65h-.686A3.4,3.4,0,0,0,12.6,4.18l.48-.48A3.969,3.969,0,0,1,14.247,6.65Z",
    transform: "translate(-417.578 -10820.784)",
    fill: "#689f38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50237",
    "data-name": "Path 50237",
    d: "M14.686,8.394H14V6.336c0-1.509,1.715-3.568,1.784-3.636l.549.412c-.48.549-1.647,2.2-1.647,3.225Z",
    transform: "translate(-418.018 -10820.471)",
    fill: "#689f38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50238",
    "data-name": "Path 50238",
    d: "M10.121,10.175,8.2,15.663c.48,1.578,1.1,2.607,1.235,3.43.274,1.3.343,4.185,1.372,6.861s1.441,4.185,3.43,5.489S17.119,33.5,18.354,33.5a7.856,7.856,0,0,0,4.8-2.058,22.549,22.549,0,0,0,3.43-4.116,25.751,25.751,0,0,0,2.744-9.605,15.933,15.933,0,0,0-2.058-8.233L21.784,4l-3.43,1.372L16.982,4s-.206.137-.48.343L16.3,6.058Z",
    transform: "translate(-416.197 -10820.879)",
    fill: "#a1887f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50239",
    "data-name": "Path 50239",
    d: "M16.125,4.5l.48,2.264a1.012,1.012,0,0,1-.549,1.1l-.206.069a1.012,1.012,0,0,0-.549,1.1l.686,4.048-2.058-3.43-2.058,5.489a13.534,13.534,0,0,1-1.372-4.8A20.9,20.9,0,0,1,7.892,15.82a14.041,14.041,0,0,1-.617-3.568C7,8.959,7,7.587,7,7.587l3.293-1.1.892,1.1-.069.686H11.8l1.372-2.058h.412l.274.686.686-.686C14.615,5.735,15.576,4.912,16.125,4.5Z",
    transform: "translate(-415.82 -10821.036)",
    fill: "#7cb342"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50240",
    "data-name": "Path 50240",
    d: "M34.663,5.489c0,4.116-.343,6.792-.686,10.977,0,.069-.343-2.333-.549-3.362a4.15,4.15,0,0,0-.549-1.441L30.753,8.439a1.188,1.188,0,0,0-1.99-.137l-.961,1.3V7.135a1.337,1.337,0,0,0-.069-.549l-.48-2.333a.962.962,0,0,0-.961-.823h-.206a1.18,1.18,0,0,0-1.166.961l-1.235,6.586L23,5.489l.686-2.058c0-2.058,1.372-2.058,1.372-2.058L25.744,0l.686,1.372L27.391.48,27.8.686c.755.549.686.549.686,2.058a22.537,22.537,0,0,0,.686,3.43s.549-1.509.686-2.058a10.246,10.246,0,0,1,1.372-2.744s.206.137.892.549a2.648,2.648,0,0,1,1.166,2.2V5.489l1.1-.412A3.138,3.138,0,0,1,34.663,5.489Z",
    transform: "translate(-420.843 -10819.623)",
    fill: "#689f38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50241",
    "data-name": "Path 50241",
    d: "M28.4,28.47A3.581,3.581,0,0,0,25.1,26c-1.99,0-2.744,2.4-2.744,2.47l-.069.274.069.206A3.1,3.1,0,0,0,25.1,30.8a3.476,3.476,0,0,0,3.225-1.784l.137-.274Zm-10.291,0A3.581,3.581,0,0,0,14.813,26c-1.99,0-2.744,2.4-2.744,2.47L12,28.744l.069.206A3.1,3.1,0,0,0,14.813,30.8a3.476,3.476,0,0,0,3.225-1.784l.137-.274Z",
    transform: "translate(-417.39 -10827.785)",
    fill: "#6d4c41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50242",
    "data-name": "Path 50242",
    d: "M12.436,6.175l.617.686c-1.372,2.058-1.372,8.233-1.372,8.233L11,9.811A4.592,4.592,0,0,1,11.75,7ZM19.914,3.43V6.175a4.012,4.012,0,0,1-.274,1.3l-.892,1.784a1.383,1.383,0,0,0-.206.755v2.333l-.617-2.2a1.765,1.765,0,0,1,.069-1.029l.961-2.2a1.758,1.758,0,0,0,0-1.441l-1.1-2.744A6.911,6.911,0,0,0,19.914,3.43Zm6.175.686v6.175L25.4,8.233l-.412.412a1.62,1.62,0,0,0-.412.617l-1.235,3.087v-.961a8.259,8.259,0,0,1,1.029-4.048,2.838,2.838,0,0,0,.343-1.3V2.744C24.717,4.254,25.746,5.42,26.089,4.116ZM23.619.48l-1.1,3.362A13.938,13.938,0,0,0,21.835,7.2l-.549,6.518V6.38A7.824,7.824,0,0,1,21.424,4.6L21.972,0A6.4,6.4,0,0,1,23.619.48Zm7,4.6A4.322,4.322,0,0,1,30,6.724,7.655,7.655,0,0,0,28.833,10.7v3.7l-.617-4.459a7.019,7.019,0,0,1,.343-3.156l.961-2.676A5.622,5.622,0,0,1,30.617,5.077Zm-14.133,4.94v3.7l-.617-3.636a1.639,1.639,0,0,0-.48-.892l-.274-.274-.206.343a4.6,4.6,0,0,0-.48,2.127v1.647l-.549-1.578a4.483,4.483,0,0,1,0-2.333l.412-1.578L14.837,4.8H15.8V7.821A1.564,1.564,0,0,0,16,8.576l.343.686A2.466,2.466,0,0,1,16.484,10.017Z",
    transform: "translate(-417.071 -10819.623)",
    fill: "#8d6e63"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28959",
    "data-name": "Group 28959",
    transform: "translate(-406.35 -10818.937)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50243",
    "data-name": "Path 50243",
    d: "M12.727,2.578c-.412-.617-2.127-.892-2.127-.892s.549,1.029,1.029,1.715a.791.791,0,0,0,1.029.274A.834.834,0,0,0,12.727,2.578Zm1.715-.686c.48-.617,2.2-.892,2.2-.892s-.549,1.029-1.029,1.715a.791.791,0,0,1-1.029.274A.841.841,0,0,1,14.442,1.892Z",
    transform: "translate(-10.6 -1)",
    fill: "#689f38"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_50244",
    "data-name": "Path 50244",
    d: "M20,39.231a12.854,12.854,0,0,1,2.47-.137c1.235.069,2.333.617,3.019.48a3.4,3.4,0,0,1-2.744,1.509A2.841,2.841,0,0,1,20,39.231Z",
    transform: "translate(-419.901 -10831.892)",
    fill: "#6d4c41"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28960",
    "data-name": "Group 28960",
    transform: "translate(-404.704 -10801.099)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50245",
    "data-name": "Path 50245",
    d: "M28.094,28.99A3,3,0,0,0,25.418,27c-1.578,0-2.127,1.99-2.127,1.99a2.456,2.456,0,0,0,2.127,1.441A2.906,2.906,0,0,0,28.094,28.99Zm-10.291,0A3,3,0,0,0,15.127,27C13.549,27,13,28.99,13,28.99a2.456,2.456,0,0,0,2.127,1.441A2.906,2.906,0,0,0,17.8,28.99Z",
    transform: "translate(-13 -27)",
    fill: "#490c0c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28961",
    "data-name": "Group 28961",
    transform: "translate(-404.155 -10801.168)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50246",
    "data-name": "Path 50246",
    d: "M27.864,28.684a2.166,2.166,0,0,1-.48,1.3,3.7,3.7,0,0,1-1.715.412,1.463,1.463,0,0,1-.823-.206,1.861,1.861,0,0,1-.755-1.578,1.972,1.972,0,0,1,.48-1.235h0a1.655,1.655,0,0,1,1.166-.48,2.492,2.492,0,0,1,1.99.892A4.722,4.722,0,0,1,27.864,28.684Zm-10.291,0a2.166,2.166,0,0,1-.48,1.3,3.7,3.7,0,0,1-1.715.412,1.463,1.463,0,0,1-.823-.206,1.861,1.861,0,0,1-.755-1.578,1.972,1.972,0,0,1,.48-1.235h0a1.655,1.655,0,0,1,1.166-.48,2.492,2.492,0,0,1,1.99.892A4.722,4.722,0,0,1,17.573,28.684Z",
    transform: "translate(-13.8 -26.9)",
    fill: "#424242"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28962",
    "data-name": "Group 28962",
    transform: "translate(-403.332 -10800.413)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50247",
    "data-name": "Path 50247",
    d: "M25.977,28a.686.686,0,1,0,.686.686A.686.686,0,0,0,25.977,28ZM15.686,28a.686.686,0,1,0,.686.686A.686.686,0,0,0,15.686,28Z",
    transform: "translate(-15 -28)",
    fill: "#e0e0e0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroot);
export default __webpack_public_path__ + "static/media/groot.1f258954d5056c7c8fe3374cb1dd533e.svg";
export { ForwardRef as ReactComponent };